import { useCallback } from 'react';
import { useDeleteCatalogItemMutation } from '../../../redux/api/fymAPI';
import { isSuccessfulResult } from '../../../redux/api/utils/isSuccessfulResult';

interface UseCatalogItemActionsProps {
  accountId: number;
}

/**
 * Un-claiming or removing a row from the Catalog row menu. The ownership and the service links
 * changed to the song page (design song-page b2, e3), with its save bar.
 */
export function useCatalogItemActions({ accountId }: UseCatalogItemActionsProps) {
  const [deleteCatalogItem, { isLoading, error }] = useDeleteCatalogItemMutation();

  const removeItem = useCallback(
    async (itemUuid: string): Promise<boolean> => {
      const result = await deleteCatalogItem({ accountId, itemUuid });
      return isSuccessfulResult(result);
    },
    [accountId, deleteCatalogItem]
  );

  return { removeItem, isLoading, error };
}
